import React from 'react';
import BlazeInputDropdown from '../../../../../../../components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { MessagingSourceType } from '../../../../../../../types/rest/assetCatalogTypes';
import _ from 'lodash';

const types = [
  { name: 'QUEUE', id: 'QUEUE' },
  { name: 'TOPIC', id: 'TOPIC' },
];

interface Props {
  selectedType: MessagingSourceType;
  onChange: (type: MessagingSourceType) => void;
  disabled?: boolean;
}

const InboundTypeDropdown = (props: Props) => {
  const getSelectedMessagingProtocol = () => {
    return _.find(types, item => item.name === props.selectedType);
  };

  return (
    <BlazeInputDropdown
      id={'MessagingTypeDropdown'}
      showGroups={false}
      items={types}
      selected={getSelectedMessagingProtocol()}
      onClick={dropdownItem => {
        props.onChange(dropdownItem.id as MessagingSourceType);
      }}
      isSearchable={false}
      isDefaultOptionSelectable={false}
      defaultOption={types[0]}
      disabled={props.disabled}
    />
  );
};

export default InboundTypeDropdown;
